"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formSubmit = exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _EditApiKeyWhitelistIpAddresses = _interopRequireDefault(require("./EditApiKeyWhitelistIpAddresses"));
var _apiKeyActions = require("../../../redux/actions/apiKeyActions");
var _modalDecorator = _interopRequireDefault(require("../../../hocs/modalDecorator"));
var _modalActions = require("../../../redux/actions/modalActions");
var _reduxForm = require("redux-form");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formName = 'editApiKeyWhiteListIpAddresses';
var formSubmit = exports.formSubmit = function formSubmit(payload, dispatch) {
  dispatch((0, _apiKeyActions.editApiKeyWhitelistIpAddress)(payload));
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    changeFieldValue: function changeFieldValue(field, value) {
      dispatch((0, _reduxForm.change)(formName, field, value));
    },
    closeModal: function closeModal() {
      return dispatch((0, _modalActions.closeModal)(_modalActions.MODAL_TYPES.EDIT_API_KEY_WHITELIST_IP_ADDRESS));
    }
  };
};
var Form = (0, _reduxForm.reduxForm)({
  form: 'editApiKeyWhiteListIpAddresses',
  onSubmit: formSubmit
})(_EditApiKeyWhitelistIpAddresses["default"]);
var container = (0, _reactRedux.connect)(null, mapDispatchToProps)(Form);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.EDIT_API_KEY_WHITELIST_IP_ADDRESS
})(container);